import { render, staticRenderFns } from "./cardQuestionAdd.vue?vue&type=template&id=5d05bb12"
import script from "./cardQuestionAdd.vue?vue&type=script&lang=js"
export * from "./cardQuestionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports